import { render, staticRenderFns } from "./BaseUser.vue?vue&type=template&id=029f5008&"
import script from "./BaseUser.vue?vue&type=script&lang=js&"
export * from "./BaseUser.vue?vue&type=script&lang=js&"
import style0 from "./BaseUser.vue?vue&type=style&index=0&id=029f5008&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports